import React, { useState, useEffect } from 'react';
import { FaBars, FaShoppingCart } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { animateScroll as scroll } from 'react-scroll';
import FairwayHuntersIcon from '../../images/logo_no_background.png'
import {
  MobileIcon,
  Nav,
  NavbarContainer,
  NavItem,
  NavLinks,
  NavLogo,
  NavIcon,
  NavMenu,
  NavBtn,
  NavBtnLink,
  NavBtnExternalLink,
  CartIconWrap,
  MobileCartIcon
} from './NavbarElements';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';

const Navbar = ({ toggle, darkText=false }) => {
  const history = useNavigate()
  const [scrollnav, setScrollnav] = useState(false);
  const { cartCount } = useCart();

  const noScrollTextColor = darkText ? "#000" : "#fff"

  const changeNav = () => {
    if (window.scrollY >= 40) {
      setScrollnav(true);
    } else {
      setScrollnav(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', changeNav);
  }, []);

  const toggleHome = () => {
    scroll.scrollToTop();
  };

  const goHome = () => {
    history("/")
  }

  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <Nav style = {{ 
            background: scrollnav ? 'rgba(13, 24, 16, 0.97)' : 'rgba(13, 24, 16, 0.15)',
            backdropFilter: scrollnav ? 'blur(8px)' : 'blur(2px)',
            borderBottom: scrollnav ? '1px solid rgba(184, 137, 42, 0.3)' : 'none',
            boxShadow: scrollnav ? "0 4px 20px rgba(0,0,0,0.4)" : "none" }} >
          <NavbarContainer>
            {/* <NavLogo onClick={toggleHome} to='/'>
              tumble
            </NavLogo> */}
            <NavIcon
              src={FairwayHuntersIcon}
              onClick={goHome}
              style={{
                filter: scrollnav
                  ? 'brightness(0) invert(1) sepia(1) saturate(0.4) hue-rotate(5deg)'
                  : 'drop-shadow(0 1px 4px rgba(0,0,0,0.5))',
                transition: 'filter 0.3s ease'
              }}
            />
            <MobileIcon onClick={toggle}>
              <FaBars color={scrollnav ? "#fff" : noScrollTextColor} />
            </MobileIcon>
            <NavMenu>
              <NavItem>
                <NavLinks
                  to='/'
                  smooth='true'
                  duration={500}
                  spy='true'
                  exact='true'
                  offset={-80}
                  style={{ color: scrollnav ? '#fff' : noScrollTextColor }}
                >
                  Home
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  to='/shop'
                  smooth='true'
                  duration={500}
                  spy='true'
                  exact='true'
                  offset={-80}
                  style={{ color: scrollnav ? '#fff' : noScrollTextColor }}
                >
                  Shop
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  to='/flyfishing'
                  smooth='true'
                  duration={500}
                  spy='true'
                  exact='true'
                  offset={-80}
                  style={{ color: scrollnav ? '#fff' : noScrollTextColor }}
                >
                  Fly Fishing
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  to='/'
                  smooth='true'
                  duration={500}
                  spy='true'
                  exact='true'
                  offset={-80}
                  style={{ color: scrollnav ? '#fff' : noScrollTextColor }}
                >
                  Our Story
                </NavLinks>
              </NavItem>
            </NavMenu>
            {/* Cart icon — hidden on mobile */}
            <CartIconWrap onClick={() => history('/cart')}>
              <FaShoppingCart size={22} color='#fff' style={{ opacity: 0.9 }} />
              {cartCount > 0 && (
                <span style={{
                  position: 'absolute',
                  top: '0', right: '0',
                  transform: 'translate(50%, -50%)',
                  background: '#B8892A', color: '#fff',
                  borderRadius: '50%', width: '17px', height: '17px',
                  fontSize: '10px', fontWeight: 700, fontFamily: 'Raleway, sans-serif',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  lineHeight: 1, zIndex: 20,
                }}>
                  {cartCount > 99 ? '99+' : cartCount}
                </span>
              )}
            </CartIconWrap>
            <MobileCartIcon onClick={() => history('/cart')}>
              <div style={{ position: 'relative', display: 'inline-flex' }}>
                <FaShoppingCart size={22} color='#fff' style={{ opacity: 0.9 }} />
                {cartCount > 0 && (
                  <span style={{
                    position: 'absolute', top: 0, right: 0,
                    transform: 'translate(50%, -50%)',
                    background: '#B8892A', color: '#fff',
                    borderRadius: '50%', width: '15px', height: '15px',
                    fontSize: '9px', fontWeight: 700, fontFamily: 'Raleway, sans-serif',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    lineHeight: 1,
                  }}>
                    {cartCount > 99 ? '99+' : cartCount}
                  </span>
                )}
              </div>
            </MobileCartIcon>
            <MobileIcon onClick={toggle}>
              <FaBars color={scrollnav ? "#fff" : noScrollTextColor} />
            </MobileIcon>
            {/* <NavBtn>
              <NavBtnExternalLink href='https://app.tumbledelivery.com/'>Login</NavBtnExternalLink>
            </NavBtn> */}
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
};

export default Navbar;